export const TEMPLATE_APP_VERSION = 'EmbIOAppVersionX.X.X';
export const SDK_VERSION = '2.20.0';
export const EMBRACE_SERVICE_NAME = 'embrace-web-sdk';
// NATIVE_FRAMEWORK is the representation Embrace BE uses to differentiate between
// sdks. It is an enum, so we just send a number here
export const NATIVE_FRAMEWORK = 1;
export const EMBRACE_APP_INSTANCE_ID_STORAGE_KEY = 'embrace_app_instance_id';
